import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import {
  ActiveBookingIntentService,
  ActiveProviderService,
  API_URL,
  SERVER_API_URL,
  apiServicesProviders,
  AuthenticationService,
  ChatDocumentViewer,
  credentialsInterceptor,
  jwtInterceptor,
  xsrfInterceptor,
  LocalStorageService,
  NAVIGATION_CONFIG,
  NavigationService,
  PORTAL_HEADER_COMPONENT,
  PORTAL_ROLE,
  PORTAL_SIDEBAR_COMPONENT,
  PORTAL_TELEHEALTH_PANEL_COMPONENT,
  provideAuthBootstrap,
  providePortalTitle,
  provideTelehealthConfig,
  ProviderPatientsService,
  RefreshTokenStateService,
  SHARED_SERVICES_DEBUG,
} from '@services';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideQuillConfig } from 'ngx-quill/config';
import { ExternalSvgModule } from '@ui-lib';
import { TelehealthCallPanelComponent } from '../../../ui-lib/src/lib/telehealth-call-panel/telehealth-call-panel.component';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { PatientChatDocumentViewer } from './chat-document-viewer.service';
import { PatientPortalHeaderComponent } from './main/shell/portal-header/patient-portal-header.component';
import { PatientPortalSidebarMenuComponent } from './main/shell/sidebar-menu/patient-portal-sidebar-menu.component';
import { NavigationConfig } from './navigation.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    providePortalTitle(),
    provideHttpClient(
      withInterceptors([
        credentialsInterceptor,
        jwtInterceptor,
        xsrfInterceptor,
      ])
    ),
    provideAnimationsAsync(),
    importProvidersFrom(ExternalSvgModule),
    provideQuillConfig({}),
    provideAuthBootstrap(),
    provideTelehealthConfig(),
    { provide: ChatDocumentViewer, useClass: PatientChatDocumentViewer },

    ...apiServicesProviders(environment.useMock),

    {
      provide: SHARED_SERVICES_DEBUG,
      useValue: !environment.production,
    },
    {
      provide: PORTAL_HEADER_COMPONENT,
      useValue: PatientPortalHeaderComponent,
    },
    {
      provide: PORTAL_TELEHEALTH_PANEL_COMPONENT,
      useValue: TelehealthCallPanelComponent,
    },
    {
      provide: PORTAL_SIDEBAR_COMPONENT,
      useValue: PatientPortalSidebarMenuComponent,
    },
    { provide: NAVIGATION_CONFIG, useValue: NavigationConfig },
    { provide: API_URL, useValue: environment.apiRootUrl },
    {
      provide: SERVER_API_URL,
      useValue: environment.serverApiRootUrl || environment.apiRootUrl,
    },
    { provide: PORTAL_ROLE, useValue: environment.role },

    AuthenticationService,
    NavigationService,
    LocalStorageService,
    RefreshTokenStateService,
    ProviderPatientsService,
    ActiveProviderService,
    ActiveBookingIntentService,
  ],
};
